<template>
  <div class='productBox'>
<div id=''></div>  
        <img :src="goods.shrink_img" class='productImg' @click='goDetail' :data-id='goods.id' style='cursor:pointer;' >
        <div class='productName'>{{goods.goods_name}}</div>
        <div class='productCate'>
          <img :src="img" v-for='img in goods.cate_imgs'>
        </div>
        <div class='productBottom'>
          <div class='dayUse' >每天{{goods.day_use}}颗</div>
          <div class='addCart' @click='addCart' :data-id='goods.id' :data-add='computCart' v-if='computCart' style='cursor:pointer;'>加入购物车</div>
          <div class='dayUse' @click='addCart' :data-id='goods.id' :data-add='computCart' v-if='!computCart' style='cursor:pointer;'>已加入</div>
        </div>
        
  </div>
</template>

<script>
export default {
  name: 'ProductBox',
  props: {
    goods: Object,
    fn: Function
  },
  data:function () {
    return{
      
   }
  },
  computed:{
    computCart(){
      let add = true
      this.$store.state.cartGoodsId.forEach((item)=>{
          if(item == this.goods.id){
            add =false
          }
      })
      return add
    }
  },
  methods: {
    goDetail(e){
		console.log(e.target.dataset.id)
      this.$router.push({path:"goods",query:{id:e.target.dataset.id}})
    },
    addCart(e){
      this.$store.commit("saveCartNum",{cartNum:this.$store.state.cartNum,goodsId:e.target.dataset.id,add:e.target.dataset.add})
      if(e.target.dataset.add){
        this.$store.commit("saveBall",{x:e.screenX,y:e.screenY})
      }
          
    },

  },
}
</script>  

<style>

.productBox{
  max-width:280px;
  max-height:380px;
  width:19.4vw;
  height:26.3vw;
  background:rgba(255,255,255,1);
  box-shadow:0px 0px 20px 0px rgba(202,196,191,0.31);
  border-radius:5px;
  filter:blur(0px);
  text-align:left;
  overflow: hidden;
  position: relative;
}
.productImg{
  max-width: 280px;
  width:19.4vw;
  max-height:203px;
  height:14.1vw;
  display: block;
}
.productName{
  font-size:20px;
  font-family:PingFangSC-Medium;
  font-weight:500;
  color:rgba(47,47,47,1);
  line-height:20px;
  padding: 1.5vw 1.5vw 10px;
}
.productCate{

  padding: 0 1.5vw;
  display:flex;
  flex-wrap: wrap;

}
.productCate img{
    width:1.6vw;
    max-width:24px;
    max-height:24px;
    height:1.6vw;
    margin-right: 5px;
    display: block;
}
.productBottom{
  max-height:50px;
  height: 4vw;
  max-width: 230px;
  width:15.9vw;
  display:flex;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  left:1.5vw;
  border-top: 1px solid rgba(229,229,229,1);
}
.dayUse{
  max-height:50px;
   height: 4vw;
  padding-top: 1vw;
  /*line-height: 2.9vw;*/
  font-size:14px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(120,120,120,1);
}
.addCart{
  max-height:50px;
   height: 4vw;
  padding-top: 1vw;
  /*line-height: 2.9vw;*/
  font-size:14px;
  font-family:PingFangSC-Medium;
  font-weight:500;
  color:rgba(194,94,77,1);
  text-decoration: underline;
}

@media only screen and (max-width: 800px) {
  .addCart,.dayUse{
    font-size: 12px;
  }
  .productName{
   font-size: 16px;
  }
}
</style>